/**
 * Normalizes errors thrown from walletAPI / axios ({ error: string }) or raw Error.
 */
export function getApiErrorMessage(err, fallback = "Something went wrong") {
  if (err == null) return fallback;
  if (typeof err === "string") return err;
  if (typeof err.error === "string" && err.error) return err.error;
  if (typeof err.message === "string" && err.message) return err.message;
  return fallback;
}
